export const Facebook = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="none"
  >
    <g clipPath="url(#clip0_1440_17374)">
      <path
        d="M24 12C24 5.37257 18.6274 -3.8147e-06 12 -3.8147e-06C5.37258 -3.8147e-06 0 5.37257 0 12C0 17.9895 4.38823 22.954 10.125 23.8542V15.4687H7.07813V12H10.125V9.35625C10.125 6.34875 11.9165 4.6875 14.6576 4.6875C15.9705 4.6875 17.3438 4.92187 17.3438 4.92187V7.875H15.8306C14.3399 7.875 13.875 8.8 13.875 9.74899V12H17.2031L16.6711 15.4687H13.875V23.8542C19.6118 22.954 24 17.9895 24 12Z"
        fill="#1877F2"
      />
      <path
        d="M16.6711 15.4688L17.2031 12H13.875V9.74899C13.875 8.80001 14.3399 7.875 15.8306 7.875H17.3438V4.92188C17.3438 4.92188 15.9705 4.6875 14.6576 4.6875C11.9165 4.6875 10.125 6.34875 10.125 9.35625V12H7.07812V15.4688H10.125V23.8542C10.7359 23.9501 11.3621 24 12 24C12.6379 24 13.2641 23.9501 13.875 23.8542V15.4688H16.6711Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1440_17374">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
